import type React from "react";
import { createSafeContext } from "~/contexts";

const [useInferenceFrameControls, InferenceFrameControlsContext] =
  createSafeContext<React.JSX.Element>("InferenceFrameControls");

export { useInferenceFrameControls };

export function InferenceFrameControlsProvider({
  element,
  children,
}: {
  element: React.JSX.Element;
  children: React.ReactNode;
}) {
  return (
    <InferenceFrameControlsContext.Provider value={element}>
      {children}
    </InferenceFrameControlsContext.Provider>
  );
}
